import { useState } from 'react';
import { cn } from "@/lib/utils";

interface TeamLogoProps {
    src?: string | null;
    name?: string | null;
    className?: string;
    imgClassName?: string;
    fallbackClassName?: string;
}

export const TeamLogo = ({ src, name, className, imgClassName, fallbackClassName }: TeamLogoProps) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    const initials = name?.charAt(0).toUpperCase() || '?';

    return (
        <div className={cn("relative flex items-center justify-center overflow-hidden", className)}>
            {/* Initials fallback - always present as background/loading state */}
            <div className={cn(
                "absolute inset-0 flex items-center justify-center bg-white/10 text-white font-bold transition-opacity duration-300",
                loaded ? "opacity-0" : "opacity-100",
                fallbackClassName
            )}>
                {initials}
            </div>

            {/* Actual Logo */}
            {src && !error && (
                <img
                    src={src}
                    alt={name || 'Team Logo'}
                    className={cn(
                        "max-w-full max-h-full object-contain transition-opacity duration-500",
                        loaded ? "opacity-100" : "opacity-0",
                        imgClassName
                    )}
                    onLoad={() => setLoaded(true)}
                    onError={() => {
                        setError(true);
                        setLoaded(false);
                    }}
                    loading="lazy"
                />
            )}
        </div>
    );
};
